import refs from '../refsLite'

export async function updateUserData(uid, updateObject) {
  await refs.userData(uid, false).update(updateObject)
}
